/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-close': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M15 5.875L14.125 5 10 9.125 5.875 5 5 5.875 9.125 10 5 14.125l.875.875L10 10.875 14.125 15l.875-.875L10.875 10z"/>'
  }
})
